<template>
<div>
    <div class="az-content-header d-block d-md-flex">
        <div>
          <h2 class="az-content-title tx-24 mg-b-5 mg-b-lg-8">Download Manual Forms</h2>
          <p class="tx-12">Please forward completed forms to: <a href="mailto:forms@tripleasuper.com.au" target="_blank">forms@tripleasuper.com.au</a></p>
        </div>
    </div><!-- az-content-header -->
    <el-row :gutter="40" class="pd-50">
        <el-col :span="10">
            <el-row :gutter="40" class="pd-t-5">               
                    <p>Triple A Super</p>
                    <a :href='tas_new' target="_blank"><div class="btn btn-secondary btn-rounded mg-b-10 tx-13" style="width:100%">Create New SMSF <i class='el-icon-download'></i></div></a>
                    <a :href='tas_transfer' target="_blank"><div class="btn btn-secondary btn-rounded mg-b-10 tx-13" style="width:100%">Transfer Existing SMSF <i class='el-icon-download'></i></div></a>
                    <a :href='tas_pension' target="_blank"><div class="btn btn-secondary btn-rounded mg-b-10 tx-13" style="width:100%">Pension Advice Form <i class='el-icon-download'></i></div></a>
            </el-row>
        </el-col>
        <el-col :span="10">
            <a :href='binding' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Binding Death Benefit Nominations <i class='el-icon-download'></i></div></a>
            <a :href='retirement' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Declaration of Retirement <i class='el-icon-download'></i></div></a>
            <a :href='windup' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Wind up Minutes - Trustees to Sign <i class='el-icon-download'></i></div></a>
            <a :href='worktest' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Work Test Template <i class='el-icon-download'></i></div></a>
            <a :href='ist' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Investment Strategy Resolution Template <i class='el-icon-download'></i></div></a>
            <a :href='is_diverse' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Investment Strategy - Diverse Mix of Assets <i class='el-icon-download'></i></div></a>
            <a :href='is_mainly' target="_blank"><div class="btn btn-info btn-rounded mg-b-10 tx-13" style="width:100%">Investment Strategy - Mainly Property <i class='el-icon-download'></i></div></a>
        </el-col>
    </el-row>
</div>

</template>
<script>
export default {
    name: 'forms',
    components: {

    },
    data(){
        return{
            binding:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/BDBN+Explanatory+Notes+%26+Forms+-+Lapsing+%26+Non-Lapsing.pdf',
            retirement:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Template+-+Declaration+of+Retirement.docx',
            windup:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Template+-+Wind+up+minutes+-+Trustees+to+sign.rtf',
            worktest:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Template+Work+Test.docx',
            ist:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Investment+Strategy+Meeting+Minutes+01092022.docx',
            is_diverse:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Investment+strategy+-+diverse+mix+of+assets+w+Profiles+01092022.doc',
            is_mainly:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Investment+strategy+-+mainly+property+w+Profiles+01092022.doc',
            choosing:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Choosing+between+Triple+A+%26+Preset+Admin+Services+SMSF+Dec19.pdf',
            ps_new:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Preset+New+SMSF+Application+Form+2019.pdf',
            ps_transfer:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Preset+SMSF+Transition+Application+Form+2019.pdf',
            ps_open:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Preset+Adviser+Macq+CMA+Establishment+Request+form_ed.pdf',
            ps_pension:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Preset+Account+Based+Pension+Advice+form.pdf',
            tas_new:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/TAS+App+for+New+SMSF+FY2023+FEV+01092022.pdf',
            tas_transfer:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/TAS+App+for+Transfer+SMSF+FY2023+EV+01092022.pdf',
            tas_open:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/Triple+A+Adviser+-+Macq+CMA+Establishment+Request+form_ed.pdf',
            tas_pension:'https://taspublic.s3.ap-southeast-2.amazonaws.com/dashboard_files/TAS+Account+Based+Pension+Advice+form.pdf',
            isSample:false,
            loading: true,
            isBGL:(JSON.parse(localStorage.getItem('userdetail')))['isBGL']

        }
    },
    
        
    
}
</script>